var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6728 18C13.3671 18 13.0626 17.8776 12.8339 17.634L8.32674 12.8341C7.8857 12.3625 7.89154 11.615 8.34191 11.1518L13.0089 6.35189C13.464 5.8827 14.2025 5.8827 14.6587 6.35189C15.1138 6.82108 15.1138 7.57946 14.6587 8.04865L10.8026 12.0145L14.5117 15.9661C14.9597 16.4436 14.9469 17.2032 14.4837 17.6628C14.2562 17.8884 13.9645 18 13.6728 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/ArrowLeftWhite.2b495abffdd3c6cb105033e8b035342b.svg";
export { ForwardRef as ReactComponent };